<template>
  <div class="articulos-wrapper">
    <comparador-articulo
      v-for="item in items"
      :key="`recuento-articulo-${item.id}`"
      :item="item"
    >
    </comparador-articulo>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ComparadorArticulo from '@/components/comparador-v2/ComparadorArticulo'

export default {
  name: 'ComparadorArticulos',
  components: {
    ComparadorArticulo
  },
  props: {
    recuento: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('comparador', ['items'])
  }
}
</script>

<style lang="scss" scoped>
.articulos-wrapper {
  margin-top: 72px;
}

span {
  display: block;

  &.item-code {
    font-weight: 700;
  }

  &.item-description {
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      overflow: visible;
    }
  }
}
</style>
